import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Container,
    Grid,
    IconButton,
    TextField
} from '@mui/material';
import { Add } from '@mui/icons-material';
import Api from 'utils/api';
import { replaceItemAtIndex } from 'utils/common';


const Settings = () => {
    const {t} = useTranslation();
    const [ settings, setSettings] = useState<{[k: string]: string}>();
    const [ added, setAdded] = useState<[string, string][]>([['', '']]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        Api.util.getSettings()
            .then(res => setSettings(res.data));
    }, []);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const data = Object.fromEntries(new FormData(event.currentTarget).entries());

        for (let i = 0; i < added.length; i++) {
            if (!added[i][0] || added[i][1] === '')
                continue;
            data[added[i][0]] = added[i][1];
        }

        Api.util.setSettings(data)
            .then(() => enqueueSnackbar(t('saved'), {
                autoHideDuration: 2000,
                variant: 'success',
            }));
    };

    return (
        <Container maxWidth="sm">
            <Card sx={{mt:2}}>
                <CardHeader
                    title={t('settings')}
                />
                <Box component="form" onSubmit={submit}>
                    <CardContent>
                        {settings && Object.entries(settings).map(([key, value]) => (
                            <Grid key={key} container columnSpacing={2}>
                                <Grid item xs={6}>
                                    {key}
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        id={key}
                                        name={key}
                                        defaultValue={value}
                                    />
                                </Grid>
                            </Grid>
                        ))}
                        {added.map(([key, value], i) => (
                            <Grid key={i} container columnSpacing={2}>
                                <Grid item xs={1}>
                                    {added.length - 1 === i && <IconButton
                                        aria-label="add row"
                                        onClick={() => setAdded(old => [...old, ['', '']])}
                                        >
                                        <Add/>
                                    </IconButton>
                                    }
                                </Grid>
                                <Grid item xs={5}>
                                    <TextField
                                        fullWidth
                                        id={`key-${i}`}
                                        value={key}
                                        onChange={e => setAdded(old => replaceItemAtIndex(old, i, [e.target.value, old[i][1]]))}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        id={`value-${i}`}
                                        value={value}
                                        onChange={e => setAdded(old => replaceItemAtIndex(old, i, [old[i][0], e.target.value]))}
                                    />
                                </Grid>
                            </Grid>
                        ))}
                    </CardContent>
                    <CardActions sx={{justifyContent: 'flex-end'}}>
                        <Button type="submit">{t('save')}</Button>
                    </CardActions>
                </Box>
            </Card>
        </Container>
    );
};

export default Settings;
